import moment from 'moment';

import * as graphql from '@treams/treams-network';
import { type CardListGroupOptions } from '@treams/treams-ui';

const UNPLANNED_GROUP_KEY = 0.5;

export function oneOnOneNoteGroupOptions(
	t: (key: string) => string,
): CardListGroupOptions<graphql.Note, number> {
	return {
		groupBy: (item) =>
			item.meeting?.startsAt
				? Math.sign(
						moment().startOf('day').diff(moment(item.meeting.startsAt).startOf('day'), 'days'),
					)
				: UNPLANNED_GROUP_KEY,
		groupTitle: (key) => {
			switch (key) {
				case UNPLANNED_GROUP_KEY:
					return t('oneOnOne.group.unplanned');
				case -1:
					return t('oneOnOne.group.future');
				case 0:
					return t('oneOnOne.group.today');
				case 1:
				default:
					return t('oneOnOne.group.past');
			}
		},
	};
}

export function sortOneOnOneNotes(a: graphql.Note, b: graphql.Note) {
	return moment(b.meeting?.startsAt).diff(moment(a.meeting?.startsAt));
}
